import { NavLink } from "react-router"
import { NAV_ITEMS } from "./sidebar"

export function DonorMobileNav() {
  return (
    <nav
      aria-label="Donor portal"
      className="flex flex-none border-t border-gold-500 bg-white px-2 pt-1.5 pb-[calc(0.375rem+env(safe-area-inset-bottom))] lg:hidden"
    >
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center gap-1 rounded-lg px-1 py-1.5 text-[0.6875rem] font-medium transition-colors ${
              isActive ? "text-forest-700" : "text-ink/50 hover:text-ink/80"
            }`
          }
        >
          <item.icon className="h-5 w-5" />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
